/***
 *
 *   APP LAYOUT
 *   Main application layout containing the navigation
 *   and header (title, secondary nav and signed in user)
 *
 *   PROPS
 *   title: title of the view
 *
 **********/

import React, { Fragment, useContext } from "react";
import { AuthContext, AppNav, Header, HelpLink, NewLookNotice, User } from "components/lib";
import Style from "./app.module.scss";
import { useNavAccess } from "./nav-access";
import { buildNavItems } from "./nav-items";

export function AppLayout(props) {
  // context & style
  const context = useContext(AuthContext);
  // optional nav items: manual screening (feature 011) for enabled accounts,
  // Workflows for switched-on accounts and owner/admin/master viewers
  const access = useNavAccess();

  return (
    <Fragment>
      <AppNav
        items={buildNavItems({
          access,
          permission: context.permission,
          signout: context.signout,
        })}
      />

      <main className={Style.app}>
        <Header title={props.title} titleAction={<HelpLink />}>
          <User />
        </Header>

        <NewLookNotice
          dismissible
          storageKey="newLookAppBannerDismissed"
          toggleText="Read about the changes"
          className="mb-6 !max-w-none"
        />

        {<props.children {...props.data} />}
      </main>
    </Fragment>
  );
}
